import {LearnMore } from '../components';
export const LearnMorePage = ()=>{

    return (<LearnMore />)
}